import store from '@/store'
import apiClient from '@/plugins/axios'
import apiClient2 from '@/plugins/axios2'


function getToken() {
  const token = store.getters['login/getToken']
  return {
    headers: {
      'Authorization': 'Bearer ' + token
    }
  }
}

export default {

  getNotificacoesUsuario() {
    const token = getToken()
    return apiClient2.get('notificacao', token)
  },

  getNotificacoes(processo_id) {
    return apiClient.get(`notificacao/index/${processo_id}`)
  },

  getNotificacoesFilter(filter) {
    return apiClient.post('notificacao/filter', filter)
  },

  getNotificacao(id) {
    return apiClient.get(`notificacao/${id}`)
  },

  postNotificacao(notificacao) {
    return apiClient.post(`notificacao`, { notificacao })

  },

  putNotificacao(id, notificacao) {
    return apiClient.put(`notificacao/${id}`, { notificacao })

  },

  putConfirmacao(id) {
    return apiClient.put(`notificacao/confirma/${id}`)
  },

  deleteNotificacao(id) {
    return apiClient.delete(`notificacao/${id}`)
  },
}


// WEBPACK FOOTER //
// ./src/views/Notificacoes/_services/index.js